var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Button } from '../../Components/Button';
import { FullScreenModalButtonContainer, FullScreenModalInfo, FullScreenModalTitle } from '../../Components/FullScreenModal';
import styles from './TimeoutSelector.module.css';
import { ErrorCircleIcon } from '../../Components/Icons';
import { red } from '../../Styles/Colours';
import { NextStepSelector } from './NextStepSelector';
export var TimeoutSelector = function (props) {
    var _a = __read(useState(true), 2), wait = _a[0], setWait = _a[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.icon },
            React.createElement(ErrorCircleIcon, { color: red, noPadding: true, noCircularContainer: true, noSizing: true })),
        React.createElement(FullScreenModalTitle, { title: 'Decision support is taking longer than usual to respond' }),
        React.createElement(FullScreenModalInfo, { info: 'Select an option to resolve the issue.' }),
        React.createElement(NextStepSelector, { shouldWait: wait, onYes: function () {
                setWait(true);
            }, onNo: function () {
                setWait(false);
            } }),
        React.createElement(FullScreenModalButtonContainer, null,
            React.createElement(Button, { key: 'noted', width: 168, type: 'button', testId: 'navigation-control-Continue', onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (wait)
                        props.onWait();
                    else
                        props.onSkip();
                } }, "Continue"))));
};
